// Options du profil commercial — un seul point de vérité, importé par ClientDetailModal (édition)
// et ClientsActiviteScreen (filtre), pour ne jamais avoir deux listes qui divergent.
export const TYPE_CLIENT_OPTIONS = ["Indépendant / artisan", "Entreprise BTP", "Fournisseur / négoce", "Particulier pro / autre"];
export const TAILLE_OPTIONS = ["Solo", "Petite équipe", "PME", "Gros compte"];
export const POTENTIEL_OPTIONS = ["Faible", "Moyen", "Fort"];
export const RELATION_OPTIONS = ["Prospect", "Client", "VIP"];

// Volume mesuré (API : VolumeClientService, seuils dans config/crm.php) —
// livraisons par mois sur 90 jours. Distinct du potentiel commercial, saisi
// au ressenti : l'écart entre les deux désigne les opportunités.
export const VOLUME_BADGE = {
  petit: { label: "Petit", bg: "secondary" },
  moyen: { label: "Moyen", bg: "primary" },
  grand: { label: "Grand", bg: "success" },
};
